/* =========================================================
   VELORA — storefront behaviour
   No dependencies. Progressive: every interaction has a
   working no-JS fallback (real links / real form posts).
========================================================= */
(function () {
  'use strict';

  var cfg = window.VELORA || {};
  var strings = cfg.strings || {};

  /* ---------- helpers ---------- */

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function formatMoney(cents) {
    var fmt = cfg.moneyFormat || '${{amount}}';
    var value = (cents / 100);
    function withComma(n, decimals, thousand, decimal) {
      n = (n || 0).toFixed(decimals);
      var parts = n.split('.');
      var int = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousand);
      return parts[1] ? int + decimal + parts[1] : int;
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
      switch (name) {
        case 'amount': return withComma(value, 2, ',', '.');
        case 'amount_no_decimals': return withComma(value, 0, ',', '.');
        case 'amount_with_comma_separator': return withComma(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withComma(value, 0, '.', ',');
        case 'amount_with_space_separator': return withComma(value, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return withComma(value, 0, ' ', ',');
        default: return withComma(value, 2, ',', '.');
      }
    });
  }

  function announce(msg) {
    var live = $('#velora-live');
    if (live) { live.textContent = ''; setTimeout(function () { live.textContent = msg; }, 60); }
  }

  var toastTimer;
  function toast(msg) {
    var el = $('#velora-toast');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('visible'); }, 2800);
  }

  /* ---------- focus trap ---------- */

  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])';
  var trapStack = [];

  function trapFocus(container, opener) {
    var entry = { container: container, opener: opener, handler: null };
    entry.handler = function (e) {
      if (e.key !== 'Tab') return;
      var items = $$(FOCUSABLE, container).filter(function (el) { return el.offsetParent !== null; });
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    };
    document.addEventListener('keydown', entry.handler);
    trapStack.push(entry);
    var target = $$(FOCUSABLE, container).filter(function (el) { return el.offsetParent !== null; })[0];
    if (target) setTimeout(function () { target.focus(); }, 60);
  }

  function releaseFocus() {
    var entry = trapStack.pop();
    if (!entry) return;
    document.removeEventListener('keydown', entry.handler);
    if (entry.opener && document.body.contains(entry.opener)) entry.opener.focus();
  }

  /* ---------- panels (drawer / menu / modal / search) ---------- */

  var openPanels = [];

  function openPanel(el, opener) {
    if (!el || el.classList.contains('open')) return;
    el.classList.add('open');
    el.removeAttribute('aria-hidden');
    document.body.classList.add('no-scroll');
    var overlay = $('#overlay');
    if (overlay && el.dataset.overlay !== 'false') overlay.classList.add('open');
    openPanels.push(el);
    trapFocus(el, opener);
    if (opener) opener.setAttribute('aria-expanded', 'true');
  }

  function closePanel(el) {
    if (!el || !el.classList.contains('open')) return;
    el.classList.remove('open');
    el.setAttribute('aria-hidden', 'true');
    openPanels = openPanels.filter(function (p) { return p !== el; });
    if (!openPanels.length) {
      document.body.classList.remove('no-scroll');
      var overlay = $('#overlay');
      if (overlay) overlay.classList.remove('open');
    }
    $$('[aria-controls="' + el.id + '"]').forEach(function (btn) { btn.setAttribute('aria-expanded', 'false'); });
    releaseFocus();
  }

  function closeTopPanel() {
    if (openPanels.length) closePanel(openPanels[openPanels.length - 1]);
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeTopPanel();
  });

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-panel-open]');
    if (opener) {
      e.preventDefault();
      openPanel($('#' + opener.getAttribute('data-panel-open')), opener);
      return;
    }
    if (e.target.closest('[data-panel-close]')) {
      e.preventDefault();
      closeTopPanel();
      return;
    }
    if (e.target.id === 'overlay') closeTopPanel();
  });

  /* ---------- announcement rotation ---------- */

  (function () {
    var track = $('[data-announcement-track]');
    if (!track) return;
    var items = $$('.announcement__item', track);
    if (items.length < 2) return;
    var i = 0;
    setInterval(function () {
      items[i].classList.remove('active');
      i = (i + 1) % items.length;
      items[i].classList.add('active');
    }, parseInt(track.dataset.announcementTrack, 10) || 5000);
  })();

  /* ---------- reveal on scroll ---------- */

  (function () {
    var els = $$('.reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) ||
        window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -60px 0px', threshold: 0.05 });
    els.forEach(function (el) { io.observe(el); });
  })();

  /* ---------- FAQ accordion ---------- */

  document.addEventListener('click', function (e) {
    var q = e.target.closest('.faq-question');
    if (!q) return;
    var item = q.closest('.faq-item');
    var isOpen = item.classList.toggle('open');
    q.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  });

  /* ---------- sticky buy bar ---------- */

  (function () {
    var bars = $$('[data-sticky-buy]');
    if (!bars.length) return;
    var anchor = $('[data-sticky-anchor]') || $('.purchase-box');
    if (!anchor) return;
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        bars.forEach(function (bar) {
          bar.classList.toggle('visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
      });
    }, { threshold: 0 });
    io.observe(anchor);
  })();

  /* ---------- quantity steppers ---------- */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty]');
    if (!btn) return;
    var wrap = btn.closest('[data-qty-wrap]');
    if (!wrap) return;
    var input = $('[data-qty-input]', wrap);
    var out = $('[data-qty-value]', wrap);
    var min = parseInt(wrap.dataset.qtyMin || '1', 10);
    var current = parseInt((input && input.value) || (out && out.textContent) || '1', 10);
    var next = Math.max(min, current + (btn.dataset.qty === 'up' ? 1 : -1));
    if (input) input.value = next;
    if (out) out.textContent = next;
    wrap.dispatchEvent(new CustomEvent('qty:change', { bubbles: true, detail: { value: next } }));
  });

  /* ---------- variant picker ---------- */

  $$('[data-variant-picker]').forEach(function (picker) {
    var form = picker.closest('form') || document;
    var data;
    try { data = JSON.parse($('[data-variant-json]', picker).textContent); } catch (err) { return; }

    function apply(variant) {
      if (!variant) return;
      var idInput = $('[data-variant-id]', form);
      if (idInput) idInput.value = variant.id;

      $$('[data-price-current]').forEach(function (el) { el.textContent = formatMoney(variant.price); });
      $$('[data-price-compare]').forEach(function (el) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          el.textContent = formatMoney(variant.compare_at_price);
          el.hidden = false;
        } else { el.hidden = true; }
      });
      $$('[data-price-badge]').forEach(function (el) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          var pct = Math.round((1 - variant.price / variant.compare_at_price) * 100);
          el.textContent = (strings.save || 'Save') + ' ' + pct + '%';
          el.hidden = false;
        } else { el.hidden = true; }
      });

      $$('[data-add-to-cart]', form).forEach(function (btn) {
        var label = $('.btn__label', btn) || btn;
        if (variant.available) {
          btn.removeAttribute('disabled');
          label.textContent = btn.dataset.labelAvailable || strings.addToCart || 'Add to cart';
        } else {
          btn.setAttribute('disabled', 'disabled');
          label.textContent = strings.soldOut || 'Sold out';
        }
      });

      if (variant.featured_media && variant.featured_media.id) {
        var thumb = $('.gallery__thumb[data-media-id="' + variant.featured_media.id + '"]');
        if (thumb) thumb.click();
      }

      if (history.replaceState && cfg.productUrl) {
        history.replaceState({}, '', cfg.productUrl + '?variant=' + variant.id);
      }
    }

    picker.addEventListener('change', function (e) {
      if (!e.target.matches('input[type="radio"]')) return;
      var variant = data.filter(function (v) { return String(v.id) === e.target.value; })[0];
      apply(variant);
    });

    var checked = $('input[type="radio"]:checked', picker);
    if (checked) {
      apply(data.filter(function (v) { return String(v.id) === checked.value; })[0]);
    }
  });

  /* ---------- gallery ---------- */

  $$('[data-gallery]').forEach(function (gallery) {
    var main = $('[data-gallery-main]', gallery);
    gallery.addEventListener('click', function (e) {
      var thumb = e.target.closest('.gallery__thumb');
      if (!thumb || !main) return;
      $$('.gallery__thumb', gallery).forEach(function (t) { t.setAttribute('aria-current', 'false'); });
      thumb.setAttribute('aria-current', 'true');
      var img = $('img', thumb);
      var mainImg = $('img', main);
      if (img && mainImg) {
        mainImg.src = img.dataset.full || img.src;
        mainImg.srcset = '';
        mainImg.alt = img.alt;
      }
    });
  });

  /* ---------- cart ---------- */

  var cartState = null;

  function cartCountUpdate(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function renderShipMeter(total) {
    var meter = $('[data-ship-meter]');
    if (!meter) return;
    var threshold = parseInt(meter.dataset.shipMeter, 10);
    if (!threshold) { meter.hidden = true; return; }
    meter.hidden = false;
    var remaining = Math.max(0, threshold - total);
    var pct = Math.min(100, (total / threshold) * 100);
    $('[data-ship-bar]', meter).style.width = pct + '%';
    var text = $('[data-ship-text]', meter);
    if (remaining === 0) {
      text.innerHTML = '<strong>' + (strings.shippingUnlocked || 'Complimentary shipping unlocked.') + '</strong>';
    } else {
      text.innerHTML = (strings.shippingRemaining || 'You are {{ amount }} away from complimentary shipping.')
        .replace('{{ amount }}', '<strong>' + formatMoney(remaining) + '</strong>');
    }
  }

  function renderCart(cart) {
    cartState = cart;
    cartCountUpdate(cart.item_count);
    renderShipMeter(cart.total_price);

    var list = $('[data-cart-lines]');
    var empty = $('[data-cart-empty]');
    var footer = $('[data-cart-footer]');
    if (!list) return;

    if (!cart.items.length) {
      list.innerHTML = '';
      if (empty) empty.hidden = false;
      if (footer) footer.hidden = true;
      return;
    }
    if (empty) empty.hidden = true;
    if (footer) footer.hidden = false;

    list.innerHTML = cart.items.map(function (item, index) {
      var media = item.image
        ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') + '" alt="" loading="lazy" width="78" height="98">'
        : '<span>' + item.product_title.split(' ').slice(0, 3).join('<br>') + '</span>';
      var variantLine = item.variant_title && item.variant_title !== 'Default Title'
        ? '<p class="cart-line__variant">' + item.variant_title + '</p>' : '';
      return '' +
        '<div class="cart-line" data-line="' + (index + 1) + '">' +
          '<div class="cart-line__media">' + media + '</div>' +
          '<div>' +
            '<h3>' + item.product_title + '</h3>' +
            variantLine +
            '<div class="cart-line__row">' +
              '<div class="qty-stepper">' +
                '<button type="button" data-line-change="' + (index + 1) + '" data-line-qty="' + (item.quantity - 1) + '" aria-label="' + (strings.decrease || 'Decrease quantity') + '">−</button>' +
                '<span>' + item.quantity + '</span>' +
                '<button type="button" data-line-change="' + (index + 1) + '" data-line-qty="' + (item.quantity + 1) + '" aria-label="' + (strings.increase || 'Increase quantity') + '">+</button>' +
              '</div>' +
              '<span class="cart-line__price">' + formatMoney(item.final_line_price) + '</span>' +
            '</div>' +
            '<button type="button" class="cart-line__remove" data-line-change="' + (index + 1) + '" data-line-qty="0">' + (strings.remove || 'Remove') + '</button>' +
          '</div>' +
        '</div>';
    }).join('');

    $$('[data-cart-subtotal]').forEach(function (el) { el.textContent = formatMoney(cart.total_price); });
  }

  function fetchCart() {
    return fetch(cfg.routes.cart + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(renderCart);
  }

  function changeLine(line, quantity) {
    return fetch(cfg.routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-line-change]');
    if (!btn) return;
    btn.disabled = true;
    changeLine(parseInt(btn.dataset.lineChange, 10), parseInt(btn.dataset.lineQty, 10))
      .then(function () { announce(strings.cartUpdated || 'Cart updated'); })
      .catch(function () { btn.disabled = false; });
  });

  /* add to cart */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form) return;
    if (!window.fetch) return; /* no-JS / old browser: let it post normally */
    e.preventDefault();

    var btn = $('[data-add-to-cart]', form);
    if (btn) btn.classList.add('is-loading');

    fetch(cfg.routes.cartAdd + '.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (body) { return { ok: r.ok, body: body }; }); })
      .then(function (res) {
        if (!res.ok) {
          toast(res.body.description || res.body.message || (strings.cartError || 'Could not add to cart'));
          return;
        }
        return fetchCart().then(function () {
          announce(strings.cartAdded || 'Added to cart');
          openPanel($('#cart-drawer'), btn);
        });
      })
      .catch(function () { toast(strings.cartError || 'Could not add to cart'); })
      .finally(function () { if (btn) btn.classList.remove('is-loading'); });
  });

  if ($('[data-cart-lines]')) fetchCart();

  /* ---------- load more reviews ---------- */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-load-more]');
    if (!btn) return;
    var hidden = $$('[data-review-hidden]');
    hidden.slice(0, 3).forEach(function (el) {
      el.hidden = false;
      el.removeAttribute('data-review-hidden');
    });
    if (!$$('[data-review-hidden]').length) btn.hidden = true;
  });

  /* ---------- header shadow on scroll ---------- */

  (function () {
    var nav = $('.nav');
    if (!nav) return;
    var last = 0;
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      if ((y > 12) !== (last > 12)) nav.classList.toggle('is-scrolled', y > 12);
      last = y;
    }, { passive: true });
  })();

})();
